<template>
  <teleport to="body" v-if="show">
    <div class="access-modal-overlay" @click.self="close">
      <div class="access-modal-container">
        <!-- Заголовок -->
        <div class="access-modal-header access-view-header">
          <div class="access-modal-header-content">
            <div class="access-modal-icon-wrapper access-view-icon">
              <i class="bx bx-show"></i>
            </div>
            <div class="access-modal-header-text">
              <h3 class="access-modal-title">Перегляд запису доступу</h3>
              <p class="access-modal-code">
                ID запиту: #REQ-{{ form.accessRequestId }}
              </p>
            </div>
          </div>
          <button class="access-modal-close" @click="close">
            <i class="bx bx-x"></i>
          </button>
        </div>

        <!-- Лоадер під час завантаження -->
        <div v-if="isLoading" class="access-modal-loading">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Завантаження...</span>
          </div>
          <p>Завантаження даних...</p>
        </div>

        <!-- Інформація про запис -->
        <template v-else-if="form.accessRequestId">
          <div class="access-modal-info">
            <div class="access-view-info-grid">
              <div class="access-view-info-item">
                <span class="access-view-info-label">Спеціаліст:</span>
                <span class="access-view-info-value">{{
                  nameWorker(form.workerId) || "-"
                }}</span>
              </div>
              <div class="access-view-info-item">
                <span class="access-view-info-label">Статус:</span>
                <span
                  :class="[
                    'access-view-badge font-bold badge',
                    mutateAccessStatusClient(form.status).color,
                  ]"
                  style="font-weight: bold"
                >
                  {{ mutateAccessStatusClient(form.status).name }}
                </span>
              </div>
              <div class="access-view-info-item">
                <span class="access-view-info-label">Створено:</span>
                <span class="access-view-info-value">{{
                  form.createdAt || "-"
                }}</span>
              </div>
              <div class="access-view-info-item">
                <!-- <span class="access-view-info-label">Дійсний до:</span> -->
                <span class="access-view-info-label">Доступ надано:</span>
                <span class="access-view-info-value">{{
                  form.lifeto || "-"
                }}</span>
              </div>
              <div class="access-view-info-item">
                <span class="access-view-info-label">Тривалість:</span>
                <span class="access-view-info-value"
                  >{{ form.accessDuration || "-" }} годин</span
                >
              </div>
              <div class="access-view-info-item">
                <span class="access-view-info-label">Компанія:</span>
                <span class="access-view-info-value">{{
                  form.companyName || "-"
                }}</span>
              </div>
            </div>
          </div>

          <!-- Тіло -->
          <div class="access-modal-body">
            <!-- Розділи -->
            <div class="access-section" v-if="form.accessRights">
              <div class="access-section-header">
                <i class="bx bx-category text-primary"></i>
                <h4 class="access-section-title">Права доступу до розділів</h4>
              </div>
              <div class="access-permissions-view-list">
                <div
                  v-for="section in sections"
                  :key="section.value"
                  class="access-permission-view-item"
                >
                  <div class="access-permission-view-header">
                    <i :class="section.icon"></i>
                    <span class="access-permission-view-label">{{
                      section.label
                    }}</span>
                  </div>
                  <span
                    :class="[
                      'access-permission-view-badge',
                      getAccessTypeClass(
                        form.accessRights?.simplePerms?.[section.value]
                      ),
                    ]"
                  >
                    {{
                      getAccessTypeLabel(
                        form.accessRights?.simplePerms?.[section.value]
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Коментар -->
            <div class="access-section" v-if="form.comment">
              <div class="access-section-header">
                <i class="bx bx-message-square-detail"></i>
                <h4 class="access-section-title">Коментар</h4>
              </div>
              <div class="access-view-comment">
                {{ form.comment }}
              </div>
            </div>

            <!-- Лінк доступу: видно лише власнику запиту або при повному доступі (perms[666]) -->
            <div
              class="access-section"
              v-if="
                canViewAccess &&
                form.status == 'approved' &&
                form.token != null
              "
            >
              <div class="access-section-header">
                <i class="bx bx-link-alt text-primary"></i>
                <h4 class="access-section-title">Посилання для доступу</h4>
              </div>
              <div class="access-link-container">
                <div class="access-link-warning">
                  <i class="bx bx-info-circle"></i>
                  <span
                    >Рекомендуємо відкрити посилання в анонімному вікні
                    браузера</span
                  >
                </div>
                <div class="access-link-box">
                  <input
                    type="text"
                    class="access-link-input"
                    :value="getAccessLink()"
                    readonly
                  />
                  <button
                    v-if="
                      this.form.token &&
                      this.form.token != null &&
                      !this.form.link
                    "
                    type="button"
                    class="access-link-copy-btn"
                    @click="getAccessLinkForRequestID()"
                  >
                    <i class="bx bx-link"></i>
                    Отримати посилання
                  </button>
                  <button
                    v-if="this.form.link && this.form.link != null"
                    type="button"
                    class="access-link-copy-btn"
                    @click="copyAccessLink"
                  >
                    <i class="bx bx-copy-alt"></i>
                    Копіювати
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Футер -->
          <div class="access-modal-footer">
            <button
              type="button"
              class="access-btn access-btn-cancel"
              @click="close"
            >
              Закрити
            </button>
            <button
              type="button"
              class="access-btn access-btn-submit"
              v-if="
                canViewAccess &&
                form.status == 'approved' &&
                form.link == null &&
                form.token == null
              "
              @click="getAccess"
            >
              Отримати доступ
            </button>
          </div>
        </template>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mutateAccessStatusClient } from "@/usabilityScripts/globalMutate.js";
import { nameWorker } from "@/usabilityScripts/getNameWorker";
import { AccessClient } from "@/API.js";
import { storeS } from "@/store";

let apiServe = new AccessClient();

export default {
  props: ["show", "obj"],
  data() {
    return {
      isLoading: false,
      form: {},

      // Розділи для відображення
      sections: [
        { value: "cashbox", label: "Каса", icon: "bx bx-money" },
        { value: "finance", label: "Фінанси", icon: "bx bx-wallet" },
        { value: "marketing", label: "Маркетинг", icon: "bx bx-bullhorn" },
        { value: "products", label: "Товари", icon: "bx bx-package" },
        { value: "programs", label: "Програма", icon: "bx bx-laptop" },
        { value: "settings", label: "Налаштування", icon: "bx bx-cog" },
        { value: "statistics", label: "Статистика", icon: "bx bx-bar-chart" },
      ],
    };
  },
  computed: {
    // Деталі доступу видно лише власнику запиту або користувачу з повним доступом (perms[666])
    canViewAccess() {
      return (
        storeS.perms[666] || this.form.workerId == storeS.userbase.userid
      );
    },
  },
  watch: {
    obj: {
      handler(newVal) {
        if (newVal) {
          this.form = { ...newVal };
          console.log("form >", this.form);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
      // Очищаємо дані при закритті
      this.form = {};
    },
    getAccess() {
      var obj = {
        accessRequestId: this.form.accessRequestId,
      };

      apiServe.createWorkerFromRequest(obj).then((response) => {
        if (response.status === "done") {
          this.$toast.success("Доступ успішно надано");
          this.updateCard(this.form);
          // this.close();
        } else {
          switch (response.error[0]) {
            case "Failed to create worker from access request":
              this.$toast.error(
                "Не вдалося створити працівника на основі заявки"
              );
              break;
            default:
              this.$toast.error("Невідома помилка");
              break;
          }
        }
      });
    },

    getAccessLinkForRequestID() {
      apiServe.getAccessLink(this.form.accessRequestId).then((response) => {
        if (response.status === "done") {
          this.form.link = response.data;
          this.$toast.success("Посилання успішно отримано");
          this.copyAccessLink();
          // this.updateCard(this.form);
          // this.close();
        } else {
          switch (response.error[0]) {
            case "Access request is not found":
              this.$toast.error("По такому ID немає заявки в системі.");
              break;
            case "Can't get a link":
              this.$toast.error(
                "У заявці немає токена чи заявка у некоректному стані."
              );
              break;
            case "accessRequestId is not set":
              this.$toast.error(
                "Параметр accessRequestId не был передан или пустой."
              );
              break;
            default:
              this.$toast.error("Невідома помилка");
              break;
          }
        }
      });
    },

    updateCard(item) {
      console.log("updateCard:", item);
      // оновлюємо картку
      apiServe.getAccessRequest(item.accessRequestId).then((response) => {
        if (response.status === "done") {
          this.form = response.data;
        } else {
          switch (response.error[0]) {
            case "ticketId is required":
              this.$toast.error("Параметр ticketId не переданий");
              break;
            default:
              this.$toast.error("Невідома помилка");
              break;
          }
        }
      });
    },
    getStatusClass(status) {
      const classMap = {
        active: "badge-success",
        pending: "badge-warning",
        rejected: "badge-danger",
        expired: "badge-secondary",
      };
      return classMap[status] || "badge-secondary";
    },

    getAccessTypeLabel(type) {
      const labels = {
        without: "Без доступу",
        view: "Перегляд",
        full: "Повний",
      };
      return labels[type] || type;
    },

    getAccessTypeClass(type) {
      const classMap = {
        without: "badge-secondary",
        view: "badge-info",
        full: "badge-success",
      };
      return classMap[type] || "badge-secondary";
    },
    // мутейт співробітника
    nameWorker(item) {
      return nameWorker(item);
    },
    mutateAccessStatusClient(e) {
      return mutateAccessStatusClient(e);
    },
    getAccessLink() {
      return this.form.link ? this.form.link : "Посилання анульоване";
    },
    copyAccessLink() {
      const url = this.getAccessLink();

      // Копіювання в буфер обміну
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$toast.success("Посилання успішно скопійовано!");
        })
        .catch((err) => {
          console.error("Помилка копіювання:", err);
          this.$toast.error("Не вдалося скопіювати посилання");
        });
    },
  },
};
</script>

<style scoped>
/* Модальне вікно overlay */
.access-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Контейнер модального вікна */
.access-modal-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Заголовок */
.access-modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px 8px 0 0;
  color: white;
}

.access-modal-header-content {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
}

.access-modal-icon-wrapper {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.access-modal-icon-wrapper i {
  font-size: 24px;
  color: white;
}

.access-modal-header-text {
  flex: 1;
}

.access-modal-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: white;
}

.access-modal-code {
  font-size: 12px;
  margin: 4px 0 0 0;
  color: rgba(255, 255, 255, 0.8);
}

.access-modal-close {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  color: white;
  flex-shrink: 0;
  cursor: pointer;
}

.access-modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.access-modal-close i {
  font-size: 20px;
}

/* Лоадер */
.access-modal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  gap: 16px;
}

.access-modal-loading p {
  margin: 0;
  font-size: 14px;
  color: #74788d;
}

/* Інформаційний блок */
.access-modal-info {
  padding: 20px 24px;
  background: #f8f9fa;
  border-bottom: 1px solid #eff2f7;
}

.access-view-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.access-view-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.access-view-info-label {
  font-size: 12px;
  color: #74788d;
  font-weight: 500;
}

.access-view-info-value {
  font-size: 13px;
  color: #495057;
  font-weight: 600;
}

.access-view-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  width: fit-content;
}

.badge-info {
  background: #e8f4f8;
  color: #50a5f1;
}

.badge-warning {
  background: #fef5e7;
  color: #f1b44c;
}

.badge-danger {
  background: #fce8e8;
  color: #f46a6a;
}

.badge-success {
  background: #e8f5e9;
  color: #34c38f;
}

.badge-secondary {
  background: #f8f9fa;
  color: #74788d;
}

/* Тіло модального вікна */
.access-modal-body {
  background: white;
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

/* Секція */
.access-section {
  margin-bottom: 20px;
}

.access-section:last-of-type {
  margin-bottom: 0;
}

.access-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.access-section-header i {
  font-size: 16px;
  color: #74788d;
}

.access-section-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #495057;
  flex: 1;
}

/* Список прав доступу для перегляду */
.access-permissions-view-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.access-permission-view-item {
  background: #f8f9fa;
  border: 1px solid #eff2f7;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.access-permission-view-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.access-permission-view-header i {
  font-size: 16px;
  color: #556ee6;
}

.access-permission-view-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}

.access-permission-view-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.access-view-comment {
  background: #f8f9fa;
  border: 1px solid #eff2f7;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #74788d;
  line-height: 1.5;
}

/* Секція з лінком доступу */
.access-link-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.access-link-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fff4e5;
  border: 1px solid #ffe6cc;
  border-radius: 6px;
  font-size: 12px;
  color: #856404;
}

.access-link-warning i {
  font-size: 16px;
  color: #f1b44c;
  flex-shrink: 0;
}

.access-link-box {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.access-link-input {
  flex: 1;
  padding: 10px 14px;
  background: #f8f9fa;
  border: 1px solid #eff2f7;
  border-radius: 6px;
  font-size: 13px;
  color: #495057;
  font-family: monospace;
  outline: none;
  transition: all 0.2s ease;
}

.access-link-input:focus {
  background: #fff;
  border-color: #0ab39c;
}

.access-link-copy-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: #0ab39c;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.access-link-copy-btn:hover {
  background: #099885;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(10, 179, 156, 0.3);
}

.access-link-copy-btn i {
  font-size: 16px;
}

/* Футер */
.access-modal-footer {
  background: white;
  padding: 16px 24px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  border-top: 1px solid #eff2f7;
}

.access-btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.access-btn-submit {
  background: #0ab39c;
  color: white;
}

.access-btn-cancel {
  background: #fff;
  color: #74788d;
  border: 1px solid #eff2f7;
}

.access-btn-cancel:hover {
  background: #f8f9fa;
  border-color: #d6dae0;
}

/* Стилі для модального вікна перегляду */
.access-view-header {
  background: #fff;
  border-bottom-color: #eff2f7;
  background: linear-gradient(135deg, #50a5f1 0%, #3b82d6 100%);
}

.access-view-header .access-modal-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
}

.access-view-header .access-modal-icon-wrapper i {
  color: white;
}

/* Адаптивність */
@media (max-width: 768px) {
  .access-modal-container {
    border-radius: 16px;
  }

  .access-view-info-grid {
    grid-template-columns: 1fr;
  }

  .access-modal-body {
    padding: 20px;
  }

  .access-modal-footer {
    flex-direction: column;
  }

  .access-btn {
    width: 100%;
    justify-content: center;
  }

  .access-link-box {
    flex-direction: column;
  }

  .access-link-copy-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
